// import idleTimer from "idle-timer";
import { useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { isEmpty } from "validate.js";
import { trackPageVisit } from "../api/common";
import { fetchLangResources } from "../app/slices/languageSlice";
import { hasAccess } from "../app/utils";
import AboutUs from "../pages/About/AboutUs";
import Contacts from "../pages/About/Contacts";
import Login from "../pages/Auth/Login";
import BookDetails from "../pages/Books/BookDetails";
import Books from "../pages/Books/Books";
import Common from "../pages/Common/Common";
import Home from "../pages/Home/Home";
import Languages from "../pages/Languages/LanguageResources";
import OpenSource from "../pages/OpenSource/OpenSource";
import Repository from "../pages/Repository/Repository";
import Uploads from "../pages/Uploads/uploadList";
import Users from "../pages/Users/UserList";
import GeneralLayout from "./GeneralLayout";
import MainLayout from "./MainLayout";
import NotFound from "./NotFound";

//* Private routes
const AppRoutes = () => {
  const dispatch = useDispatch();
  const { activeSession } = useSelector(({ auth }) => auth);

  //* load language

  if (isEmpty(localStorage.getItem("languageResources"))) {
    dispatch(fetchLangResources());
  }

  let location = useLocation();
  let isUserAuthenticated =
    activeSession && activeSession?.hasOwnProperty("USERNAME") ? true : false;

  const logout = () => {};

  const onIdle = () => {
    if (activeSession?.hasOwnProperty("TOKEN")) dispatch(logout());
  };

  const onActive = () => {};

  useIdleTimer({
    callback: onIdle,
    activeCallback: onActive,
    idleTime: 300000,
  });

  useEffect(() => {
    trackPageVisit(location.pathname);
  }, [location.pathname]);

  //* builders
  const publicRoute = ({
    component: Component,
    path,
    layout: Layout,
    ...props
  }) => {
    return (
      <Route
        path={path}
        element={
          <Layout>
            <Component {...props} />
          </Layout>
        }
      />
    );
  };

  const privateRoute = ({
    component: Component,
    layout: Layout,
    path,
    allowedRoles,
    ...props
  }) => {
    if (isUserAuthenticated === false) {
      return (
        <Route
          path={path}
          element={<Navigate to={"/"} state={{ from: location }} />}
        />
      );
    }

    if (
      allowedRoles && 
      !allowedRoles.includes(activeSession?.role) && 
      !allowedRoles.includes(activeSession?.ROLE_ID) &&
      !allowedRoles.includes(activeSession?.ROLE_NAME)
    ) {
      return (
        <Route
          path={path}
          element={<Navigate to={"/"} state={{ from: location }} />}
        />
      );
    }

    if (hasAccess({ type: "path", resource: location.pathname }) === false) {
      return (
        <Route
          path={path}
          element={<Navigate to={"/404"} state={{ from: location }} />}
        />
      );
    }
    return (
      <Route
        path={path}
        element={
          <Layout>
            <Component {...props} />
          </Layout>
        }
      />
    );
  };

  return (
    <Routes>
      {/* public routes */}

      {publicRoute({
        path: "/",
        component: Home,
        layout: MainLayout,
      })}

      {publicRoute({
        path: "/books",
        layout: MainLayout,
        component: Books,
      })}

      {publicRoute({
        path: "/books/details",
        layout: MainLayout,
        component: BookDetails,
      })}

      {publicRoute({
        path: "/repository",
        layout: MainLayout,
        component: Repository,
      })}

      {publicRoute({
        path: "/books/details",
        layout: MainLayout,
        component: BookDetails,
      })}
      {publicRoute({
        path: "/aboutUs",
        layout: MainLayout,
        component: AboutUs,
      })}
      {publicRoute({
        path: "/contactUs",
        layout: MainLayout,
        component: Contacts,
      })}

      {publicRoute({
        path: "/openSource",
        layout: MainLayout,
        component: OpenSource,
      })}

      {publicRoute({
        path: "/mkutubi",
        layout: GeneralLayout,
        component: Login,
      })}

      {/* To be Private Routes */}

      {privateRoute({
        path: "/common",
        layout: MainLayout,
        component: Common,
      })}

      {privateRoute({
        path: "/users",
        layout: MainLayout,
        component: Users,
      })}

      {privateRoute({
        path: "/uploads",
        layout: MainLayout,
        component: Uploads,
      })}

      {privateRoute({
        path: "/languages",
        layout: MainLayout,
        component: Languages,
      })}

      {/* Not Found*/}
      <Route
        element={
          <MainLayout>
            <NotFound />
          </MainLayout>
        }
        path="/404"
      />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
};

export default AppRoutes;
